import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import AdminBillRow from './adminBillRow.js';
import { Link } from 'react-router-dom';
import { getBills } from './billsActions';
import { connect } from 'react-redux';
import Loader from '../../components/loader';
import ErrorMessage from '../../components/errorMessage';
import Helmet from 'react-helmet';

const AdminBillsGrouped = ({ getBills, bills, error, loading }) => {
  useEffect(() => {
    if (!bills) {
      getBills({ onlyUnpaid: true });
    }
  }, []);

  const groupedBills = [];

  if (bills) {
    bills.forEach((bill) => {
      const existingGbIndex = groupedBills.findIndex((gb) => gb.userId === bill.user.id);
      if (existingGbIndex === -1) {
        const to = bill.to
          ? bill.to.className === 'CompanyBillDetails'
            ? bill.to.companyName
            : bill.to.fullName
          : '-';
        groupedBills.push({
          userId: bill.user.id,
          to,
          bills: [bill],
        });
      } else {
        groupedBills[existingGbIndex].bills.push(bill);
      }
    });
  }
  const { formatMessage } = useIntl();

  return (
    <div>
      <Helmet>
        <title>{formatMessage({ id: 'admin.bills.title' })}</title>
      </Helmet>
      <h3>
        <FormattedMessage id={'admin.bills.title'} />
      </h3>

      <Loader show={loading} />
      <ErrorMessage error={error} />

      <div className="m-b-2">
        <Link className="btn btn-default" to={`/admin/bills`}>
          <FormattedMessage id={'admin.bills.cta.unpaid'} />
        </Link>
      </div>

      <table className="table table-striped admin__table m-b-6">
        <thead>
          <tr>
            <th scope="col">Bill id</th>
            <th scope="col">To</th>
            <th scope="col">From</th>
            <th scope="col">Amount</th>
            <th scope="col">Status</th>
            <th scope="col">Deadline</th>
            <th scope="col">Date created</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {groupedBills
            ? groupedBills.map((gb, index) => (
                <>
                  <tr>
                    <td className="admin__table-separator" colspan="8">
                      <h4 className="m-b-0">{gb.to}</h4>
                    </td>
                  </tr>
                  {gb.bills.map((bill, index) => (
                    <AdminBillRow showDeadline={true} bill={bill} key={index} />
                  ))}
                  <td className="admin__table-separator m-bottom" colSpan="8" />
                </>
              ))
            : ''}
        </tbody>
      </table>
    </div>
  );
};

AdminBillsGrouped.propTypes = {
  setLoading: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
};

AdminBillsGrouped.defaultProps = {};

function mapStateToProps(state) {
  return {
    bills: state.bills.bills,
    loading: state.bills.loading,
    error: state.bills.error,
  };
}

const mapDispatchToProps = {
  getBills,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminBillsGrouped);
